/**
 * Cards carousel Block JavaScript
 *
 * @package TekCreative
 * @since 2.0.0
 */

import SplideCarousel from '../../../../javascript/components/splide.js';

(function() {
    'use strict';

    const FourColCards001 = {
        selector: '.four-col-cards-001',

        init() {
            const blocks = document.querySelectorAll(this.selector);
            if (!blocks.length) return;

            blocks.forEach(block => this.initBlock(block));
        },

        initBlock(block) {
            this.initCarousel(block);
        },

        initCarousel(block) {
            // Find all splide-carousel elements within this block and initialize them
            const sliders = block.querySelectorAll('.splide-carousel');
            sliders.forEach(slider => {
                SplideCarousel.init(slider);
            });
        },
    };

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => FourColCards001.init());
    } else {
        FourColCards001.init();
    }

    // Re-initialize for Gutenberg editor preview
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=four-col-cards-001', () => {
            setTimeout(() => FourColCards001.init(), 100);
        });
    }

})();
